export interface SegmentedOption {
  value: string;
  label: string;
}

interface SegmentedProps {
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function Segmented({ options, value, onChange, disabled }: SegmentedProps) {
  return (
    <div
      className={`inline-flex items-center rounded-full bg-background-100 p-1 border border-background-200 ${
        disabled ? 'opacity-50 pointer-events-none' : ''
      }`}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors duration-150 cursor-pointer ${
              active
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-700 hover:text-foreground-950'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}